<template>
<div class="main-panel">
    <top-navbar></top-navbar>
    <div class="content">
        <div class="row">
            <div class="col-md-6 rolelist">
                <div class="">
                    <h5 class=""></h5>
                </div>
            </div>

            <div class="col-md-12 rolelistupper">
                <div class="card">
                    <h5 class="card-title">Cart List</h5>

                    <FlashMessage :position="'right top'"></FlashMessage>

                    <div class="card-body table-responsive table-full-width">

                        <table class="table table-borderd mt-5" id="myTable">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>User</th>
                                    <th>Number</th>
                                    <th>Email</th>
                                    <th>Products</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="data in tableData" v-bind:key="data.roleid">
                                    <td>{{data.cartid}}</td>
                                    <td>{{data.name}}</td>
                                    <td>{{data.number}}</td>
                                    <td>{{data.email}}</td>
                                    <td>
                                        <router-link :to="'/admin/dashboard/cart-detail/'+data.userid">{{data.totalproducts}}</router-link>
                                    </td>
                                </tr>
                            </tbody>

                        </table>

                    </div>
                </div>
            </div>
        </div>

    </div>
    <content-footer></content-footer>
</div>
</template>

    
<script>
import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
import datatable from "datatables.net-bs4"
import Auth from '../../../Auth.js';
import Vue from 'vue'
import $ from "jquery"
import {
    Table,
    TableColumn
} from 'element-ui'
Vue.use(Table)
Vue.use(TableColumn)
export default {
    name: 'cart',

    components: {
        TopNavbar,
        ContentFooter,
    },

    data() {
        return {
            tableData: [],
            Auth: '',
        }
    },

    methods: {

        table() {
            this.$nextTick(() => {
                $('#myTable').DataTable();
            });
        },

        getData() {
            this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/cart`).then((res) => {
                this.tableData = res.data;
                this.table();

            });
        },

    },

    mounted() {
        this.getData();
        this.Auth = Auth.user;
    },

};
</script>

    
<style lang="scss">

    </style>
